import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setSpaceSize, setSpaceSizeUnits } from 'bundles/apex/deals/form/store/deal/actions';

import Area from 'bundles/apex/deals/form/fields/area';

export function SpaceSize({ setSpaceSize, setSpaceSizeUnits }) {
  return (
    <Area
      name="spaceSize"
      onUnitsChange={setSpaceSizeUnits}
      onValueChange={setSpaceSize}
    />
  );
}

SpaceSize.propTypes = {
  setSpaceSize: PropTypes.func.isRequired,
  setSpaceSizeUnits: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setSpaceSize,
  setSpaceSizeUnits,
};

export default connect(null, mapDispatchToProps)(SpaceSize);
